module.exports = "https://static.energy5.com/_next/static/images/faqHeaderBg-164e3f3011ae405c514bd4aa1a8c4eaa.webp";